import { render } from "./SolicitarRecuperacion.vue?vue&type=template&id=2fb82e0e&scoped=true"
import script from "./SolicitarRecuperacion.vue?vue&type=script&lang=js"
export * from "./SolicitarRecuperacion.vue?vue&type=script&lang=js"

import "./SolicitarRecuperacion.vue?vue&type=style&index=0&id=2fb82e0e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb82e0e"]])

export default __exports__